"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AuthState", {
  enumerable: true,
  get: function get() {
    return _AuthState["default"];
  }
});
Object.defineProperty(exports, "ECommLoginService", {
  enumerable: true,
  get: function get() {
    return _ECommLoginService["default"];
  }
});
Object.defineProperty(exports, "ECommLoginServiceConfiguration", {
  enumerable: true,
  get: function get() {
    return _ECommLoginService.ECommLoginServiceConfiguration;
  }
});
Object.defineProperty(exports, "ECommLoginServiceConfigurationUAT", {
  enumerable: true,
  get: function get() {
    return _ECommLoginService.ECommLoginServiceConfigurationUAT;
  }
});
Object.defineProperty(exports, "ECommLoginServiceConfigurationPPE", {
  enumerable: true,
  get: function get() {
    return _ECommLoginService.ECommLoginServiceConfigurationPPE;
  }
});
Object.defineProperty(exports, "ECommLoginServiceConfigurationProd", {
  enumerable: true,
  get: function get() {
    return _ECommLoginService.ECommLoginServiceConfigurationProd;
  }
});
Object.defineProperty(exports, "LegalECommLoginServiceConfiguration", {
  enumerable: true,
  get: function get() {
    return _ECommLoginService.LegalECommLoginServiceConfiguration;
  }
});
Object.defineProperty(exports, "LegalECommLoginServiceConfigurationUAT", {
  enumerable: true,
  get: function get() {
    return _ECommLoginService.LegalECommLoginServiceConfigurationUAT;
  }
});
Object.defineProperty(exports, "LegalECommLoginServiceConfigurationPPE", {
  enumerable: true,
  get: function get() {
    return _ECommLoginService.LegalECommLoginServiceConfigurationPPE;
  }
});
Object.defineProperty(exports, "LegalECommLoginServiceConfigurationProd", {
  enumerable: true,
  get: function get() {
    return _ECommLoginService.LegalECommLoginServiceConfigurationProd;
  }
});
Object.defineProperty(exports, "EMCMLoginService", {
  enumerable: true,
  get: function get() {
    return _EMCMLoginService["default"];
  }
});
Object.defineProperty(exports, "EMCMLoginServiceConfiguration", {
  enumerable: true,
  get: function get() {
    return _EMCMLoginService.EMCMLoginServiceConfiguration;
  }
});
Object.defineProperty(exports, "EMCMLoginServiceConfigurationUAT", {
  enumerable: true,
  get: function get() {
    return _EMCMLoginService.EMCMLoginServiceConfigurationUAT;
  }
});
Object.defineProperty(exports, "EMCMLoginServiceConfigurationPPE", {
  enumerable: true,
  get: function get() {
    return _EMCMLoginService.EMCMLoginServiceConfigurationPPE;
  }
});
Object.defineProperty(exports, "EMCMLoginServiceConfigurationProd", {
  enumerable: true,
  get: function get() {
    return _EMCMLoginService.EMCMLoginServiceConfigurationProd;
  }
});
Object.defineProperty(exports, "FakeLoginService", {
  enumerable: true,
  get: function get() {
    return _FakeLoginService["default"];
  }
});
exports["default"] = void 0;

var _AuthState = _interopRequireDefault(require("./AuthState"));

var _LoginManager = _interopRequireDefault(require("./LoginManager"));

var _ECommLoginService = _interopRequireWildcard(require("./services/ECommLoginService"));

var _EMCMLoginService = _interopRequireWildcard(require("./services/EMCMLoginService"));

var _FakeLoginService = _interopRequireDefault(require("./services/FakeLoginService"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _LoginManager["default"];
exports["default"] = _default;